import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", width: "1em", height: "1em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M10.429 23v-9.429H1.001v-3.142h9.429V1h3.143v9.429h9.428v3.142h-9.429V23z" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
